/**
 * Walking a mission's plan: plan items → packages (actions) → tasks (action items).
 *
 * A leaf module: it imports nothing, so anything can use it without making an import cycle.
 * Cycles are why comp/MissionUtils, utils/actionItem and utils/mf-utils each kept their own
 * copy of getAllActionItems; they now re-export this one.
 */

/** Every task on the mission's plan, in plan order (one pass, not a copy per package) */
export function getAllActionItems(mission) {
    if (!mission?.planItems) {
        return []
    }
    const out = []
    for (const p of mission.planItems) {
        for (const a of p?.actions || []) {
            if (a?.actionItems?.length) out.push(...a.actionItems)
        }
    }
    return out
}
